/**
 * PingOne OpenID Connect/OAuth 2 protocol API
 */
import request from "superagent";
import {pingOneConfig} from "../pingOneAuthConfig";
import { getConfig } from '../utils/config';

/******************************************************************************
 *         OAuth 2/OpenID Connect Protocol API
 ******************************************************************************/

/**
 *  Authorize the client
 *
 * @param state a string that specifies an optional parameter that is used to maintain state between the logout request and the callback to the endpoint specified by the post_logout_redirect_uri query parameter.
 * @param nonce a string that is used to associate a client session with an ID token, and to mitigate replay attacks. The value is passed through unmodified from the authentication request to the ID token.
 */
const authorize = (state, nonce) => {
  let authUrl = `${getBaseApiUrl(
      true)}/as/authorization.oauth2?` +
      `client_id=${pingOneConfig.clientId}&` +
      `redirect_uri=${pingOneConfig.redirectUri}&`+
      `response_type=${pingOneConfig.responseType ? pingOneConfig.responseType: 'code'}` +
      (pingOneConfig.prompt ? `&prompt=${pingOneConfig.prompt}` : '') +
      (pingOneConfig.scope ? `&scope=${pingOneConfig.scope}` : '') +
      (state ? `&state=${state}` : '') +
      (nonce ? `&nonce=${nonce}` : '');
  window.location.replace(authUrl);
};

const getBaseApiUrl = (useAuthUrl) => {
  const nodeEnv = getConfig('REACT_APP_NODE_ENV');
  console.log(" ENV :" , nodeEnv);
  console.log(" Redirect URI :" , pingOneConfig.redirectUri);
  const currentUrl = window.location.href;
  console.log(currentUrl);
  if(nodeEnv === "qa"){
    console.log("IN QA")
  }

  if(nodeEnv === "production"){
    return useAuthUrl ?
    'https://pingfederate.prod-genpt.us2.ping.cloud' :
    'https://pingfederate.prod-genpt.us2.ping.cloud/as/token.oauth2'
  }else if(nodeEnv === "development"){

     return useAuthUrl ?
     'https://pingfederate.stage-genpt.us2.ping.cloud' :
     'https://pingfederate.stage-genpt.us2.ping.cloud/as/token.oauth2'

  }else if(nodeEnv === "qa"){

     return useAuthUrl ?
     'https://pingfederate.stage-genpt.us2.ping.cloud' :
     'https://pingfederate.stage-genpt.us2.ping.cloud/as/token.oauth2'

  }else if(nodeEnv === "stress"){

     return useAuthUrl ?
     'https://pingfederate.stage-genpt.us2.ping.cloud' :
     'https://pingfederate.stage-genpt.us2.ping.cloud/as/token.oauth2'

  }
  
    // API_URI: 'https://pingfederate.stage-genpt.us2.ping.cloud/as/token.oauth2',
    // AUTH_URI: 'https://pingfederate.stage-genpt.us2.ping.cloud',

  


};


/**
 * Ends the user session associated with the given ID token.
 * @param token  - a required attribute that specifies the ID token passed to the logout endpoint as a hint about the user's current authenticated session.
 * @param state - a string that specifies an optional parameter that is used to maintain state between the logout request and the callback to the endpoint specified by the logoutRedirectUri query parameter
 * @see {@link https://openid.net/specs/openid-connect-session-1_0.html#RPLogout|RP-Initiated Logout}
 */
const signOff = (token, state) => {
  let singOffUrl = `${getBaseApiUrl(
      true)}/${pingOneConfig.environmentId}/as/signoff?id_token_hint=${token}`;
  if (pingOneConfig.logoutRedirectUri && state) {
    singOffUrl = singOffUrl.concat(
        `&post_logout_redirect_uri=${pingOneConfig.logoutRedirectUri}&state=${state}`);
  }
  window.location.assign(singOffUrl);
};


/**
 * Obtain an access token in a format of:
 * {access_token: "bla", token_type: "Bearer", expires_in: 3600, scope: "address phone openid profile email", id_token: "bla"}
 *
 * Note that authentication requirements to this endpoint are configured by the application's tokenEndpointAuthMethod property
 * @param code a string that specifies the authorization code returned by the authorization server. This property is required only if the grant_type is set to authorization_code
 */
const getAccessToken = (code) => {
  return get(`${pingOneConfig.redirectUri}api/v1/auth/token/${code}`, true);
  // https://costmanagement.dev.genpt.com/api/v1/auth/token/
};

const get = (apiPath, getBody = false, headers = {}) =>
    new Promise((resolved, rejected) =>
        request
        .get(apiPath)
        .set(headers)
        .end((err, res) => {
          if (err) {
            rejected(res ? res.body : err);
          } else {
            resolved(getBody ? res.body : res);
          }
        }));
      

const parseHash = () => {
  return window.location.hash.replace('#', '').split('&').reduce(
      (prev, item) => {
        return Object.assign(
            {[item.split('=')[0]]: decodeURIComponent(item.split('=')[1])},
            prev);
      }, {});
};

const generateRandomValue = () => {
  let crypto = window.crypto || window.msCrypto;
  let D = new Uint32Array(2);
  crypto.getRandomValues(D);
  return D[0].toString(36);
};


const ssoApis = {
  authorize,
  signOff,
  getAccessToken,
  parseHash,
  generateRandomValue
}

export default ssoApis;
